/** @format */
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { digitalContentService } from '../../Services/digitalContent.services';

const CONTENT_TYPES = [
  { value: 'image', labelKey: 'DigitalContent-ContentType-Image' },
  { value: 'video', labelKey: 'DigitalContent-ContentType-Video' },
  { value: 'text', labelKey: 'DigitalContent-ContentType-Text' },
];

const AddDigitalContent = ({ onSuccess, setResultModal, disabled }) => {
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, watch } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const [filePreview, setFilePreview] = useState(null);
  const contentType = watch('contentType');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFilePreview(URL.createObjectURL(file));
    }
  };

  const onSubmit = async (data) => {
    const payload = {
      contentType: data.contentType,
      duration: data.duration,
      validFrom: data.validFrom,
      validTo: data.validTo,
    };

    if ((data.contentType === 'image' || data.contentType === 'video') && data.contentFile && data.contentFile[0]) {
      const file = data.contentFile[0];
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
      payload.content = base64;
    } else if (data.contentType === 'text' && data.contentUrl) {
      payload.content = data.contentUrl;
    }

    digitalContentService
      .create(payload)
      .then((res) => {
        onSuccess();
        setFilePreview(null);
        setResultModal({
          show: true,
          title: translator('DigitalContent-Add-SuccessModal-Title'),
          text: translator(res.data.message),
          btnClass: 'btn btn-primary',
        });
      })
      .catch((err) => console.log(err));
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className='p-4'
      style={{ border: '1px solid lightgray' }}>
      <h5 className='mb-4 text-center font-weight-bold'>
        {translator('DigitalContent-AddNew')}
      </h5>

      <fieldset className='scheduler-border'>
        <div className='form-group'>
          <label>{translator('DigitalContent-ContentType')}</label>
          <select
            className='form-control'
            name='contentType'
            ref={register({ required: true })}
            disabled={disabled}>
            <option value=''>{translator('DigitalContent-ContentType-Select')}</option>
            {CONTENT_TYPES.map((ct) => (
              <option key={ct.value} value={ct.value}>
                {translator(ct.labelKey)}
              </option>
            ))}
          </select>
          {errors.contentType && errors.contentType.type === 'required' && (
            <p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
          )}
        </div>

        {(contentType === 'image' || contentType === 'video') && (
          <div className='form-group'>
            <label>{translator('DigitalContent-ContentFile')}</label>
            <input
              type='file'
              className='form-control-file'
              name='contentFile'
              accept={contentType === 'image' ? 'image/*' : 'video/*'}
              ref={register({ required: true })}
              onChange={handleFileChange}
              disabled={disabled}
            />
            {errors.contentFile && errors.contentFile.type === 'required' && (
              <p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
            )}
            {filePreview && contentType === 'image' && (
              <img src={filePreview} alt='preview' className='mt-2' style={{ maxHeight: 120 }} />
            )}
            {filePreview && contentType === 'video' && (
              <video src={filePreview} className='mt-2' style={{ maxHeight: 120 }} controls />
            )}
          </div>
        )}

        {contentType === 'text' && (
          <div className='form-group'>
            <label>{translator('DigitalContent-ContentText')}</label>
            <textarea
              className='form-control'
              name='contentUrl'
              rows={4}
              ref={register({ required: true })}
              disabled={disabled}
            />
            {errors.contentUrl && errors.contentUrl.type === 'required' && (
              <p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
            )}
          </div>
        )}

        <div className='form-group'>
          <label>{translator('DigitalContent-Duration')}</label>
          <input
            type='number'
            className='form-control'
            name='duration'
            min={1}
            ref={register({ required: true, min: 1 })}
            disabled={disabled}
          />
          {errors.duration && errors.duration.type === 'required' && (
            <p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
          )}
          {errors.duration && errors.duration.type === 'min' && (
            <p className='text-danger'>{translator('ValidationMsg-MinValue1')}</p>
          )}
        </div>

        <div className='form-row'>
          <div className='form-group col-6'>
            <label>{translator('DigitalContent-ValidFrom')}</label>
            <input
              type='date'
              className='form-control'
              name='validFrom'
              ref={register({ required: true })}
              disabled={disabled}
            />
            {errors.validFrom && errors.validFrom.type === 'required' && (
              <p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
            )}
          </div>

          <div className='form-group col-6'>
            <label>{translator('DigitalContent-ValidTo')}</label>
            <input
              type='date'
              className='form-control'
              name='validTo'
              ref={register({ required: true })}
              disabled={disabled}
            />
            {errors.validTo && errors.validTo.type === 'required' && (
              <p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
            )}
          </div>
        </div>
      </fieldset>

      <div className='d-flex justify-content-end mt-2'>
        <button className='btn btn-primary' type='submit' disabled={disabled}>
          {translator('Btn-Save')}
        </button>
      </div>
    </form>
  );
};

export default AddDigitalContent;
